import { SlideLoveCover } from './SlideLoveCover'
import { SlideLifecycleTail } from './SlideLifecycleTail'
import { SlideFormatByPhase } from './SlideFormatByPhase'
import { SlideAgencyOfRecord } from './SlideAgencyOfRecord'
import { SlideSnakDefinition } from './SlideSnakDefinition'
import { SlideOperatingScale } from './SlideOperatingScale'
import { SlideCampaignFlowMockups } from './SlideCampaignFlowMockups'
import { Slide03Background } from './Slide03Background'
import { SlideMasterSnaks } from './SlideMasterSnaks'
import { SlideGovernanceView } from './SlideGovernanceView'
import { SlideCountryBrandView } from './SlideCountryBrandView'
import { SlideCustomerJourneyExamples } from './SlideCustomerJourneyExamples'

export const slides = [
  SlideLoveCover,
  SlideAgencyOfRecord,
  SlideLifecycleTail,
  SlideFormatByPhase,
  SlideSnakDefinition,
  SlideCustomerJourneyExamples,
  SlideCampaignFlowMockups,
  SlideOperatingScale,
  Slide03Background,
  SlideMasterSnaks,
  SlideGovernanceView,
  SlideCountryBrandView,
]

export const slideTitles: { section: string; title: string }[] = [
  { section: 'Cover', title: 'All You Need Is Love' },
  { section: '02', title: 'Snak Agency of Record' },
  { section: '03', title: 'Three Priorities Across the Product Lifecycle' },
  { section: '04', title: 'As Familiarity Grows, Format Shortens' },
  { section: '05', title: 'HCPs Don’t Lack Content. They Lack Time.' },
  { section: '06', title: 'Snaks Throughout the Customer Journey' },
  { section: '07', title: 'Banner to Snak to Insight' },
  { section: '08', title: 'Built for Continued Campaigns' },
  { section: '09', title: 'More Channels to Share' },
  { section: '10', title: 'Suggested Further Master Snaks' },
  { section: '11', title: 'One Governance View' },
  { section: '12', title: 'By Country and by Brand' },
]
